import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ProfilePage from './pages';

function ProfileRoute() {
	return (
		<Routes>
			<Route path="/" element={<ProfilePage />} />
		</Routes>
	);
}

export default ProfileRoute;
